"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LIVE_STATUSES;
(function (LIVE_STATUSES) {
    LIVE_STATUSES["SCHEDULED"] = "item-scheduled";
    LIVE_STATUSES["STREAMING"] = "item-live";
    LIVE_STATUSES["FINALIZING"] = "item-live-finalize";
})(LIVE_STATUSES = exports.LIVE_STATUSES || (exports.LIVE_STATUSES = {}));
var STREAM_STATUSES;
(function (STREAM_STATUSES) {
    STREAM_STATUSES["READY"] = "READY";
    STREAM_STATUSES["PENDING"] = "PENDING";
})(STREAM_STATUSES = exports.STREAM_STATUSES || (exports.STREAM_STATUSES = {}));
//# sourceMappingURL=live-statuses.js.map